import { getSnowplowEventPayload, logAnalyticsEvents } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, ANALYTICS_PROVIDERS, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

import type { GalleryEvent } from '../galleryEventsRedesign/types';

const { PURCHASE_SUMMARY } = ANALYTICS_CATEGORIES;
const { SNOWPLOW } = ANALYTICS_PROVIDERS;
const { CLICK } = SNOWPLOW_EVENTS;

export const triggerKeyDocumentsGalleryOpenedEvent = ({ kind }: GalleryEvent): void => {
	logAnalyticsEvents([
		{
			eventPayload: getSnowplowEventPayload({
				category: PURCHASE_SUMMARY,
				customData: { label: kind },
				name: `dlr_key_documents_gallery_opened`,
				schemaName: CLICK.SCHEMA,
				version: CLICK.VERSION,
			}),
			provider: SNOWPLOW,
		},
	]);
};
